import React from 'react';
import type { BrainAtlasType, MultiLang } from '../../../../config';
import ItemUtil from '../../../lib/ItemUtil';
import ItemType from '../..';

interface Props {
    lang: MultiLang;
    relatedTo: number[];
    type: BrainAtlasType;
}

const RelatedTo: React.FC<Props> = (props) => {
    const { lang, relatedTo, type } = props;
    const isMounted = React.useRef<boolean>(false);

    const [elements, setElements] = React.useState<React.ReactNode[]>([]);

    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    React.useEffect(() => {
        if (relatedTo.length === 0) {
            setElements([]);
        } else {
            ItemUtil.getList(type, relatedTo, (results) => {
                const elements = results.data.map((item, idx) => {
                    const evenodd = idx % 0 ? 'even' : 'odd';
                    return (
                        <tr key={item.item_id}>
                            <td className={evenodd}>
                                <ItemType.List lang={lang} item={item} type={type} />
                            </td>
                        </tr>
                    );
                });
                if (isMounted.current) {
                    setElements(elements);
                }
            });
        }
    }, [lang, relatedTo, type]);

    if (elements.length === 0) {
        return null;
    }
    return (
        <table className="listTable">
            <tbody>
                <tr>
                    <th>Item summary</th>
                </tr>
                {elements}
            </tbody>
        </table>
    );
};

export default RelatedTo;
